<template>
  <!--v-show="showFlag==true"-->
  <div v-show="showFlag==true" class="tipsBox">
    {{content}}
  </div>
</template>
<script>
  export default {
    name:'toastTips',
    props:['isShow','content'],
    data () {
      return {
        showFlag:this.isShow
      }
    },
    mounted:function(){

    },
    watch:{
      isShow:function(){
        var that=this;
        console.log(that.isShow);
        that.showFlag=that.isShow;
        if(that.isShow==true){
          setTimeout(function(){
            that.showFlag = false;
          },3000)
        }
      }
    }
  }
</script>
<style>
  .tipsBox{
    position: fixed;
    left:50%;
    top:40%;
    z-index: 2000;
    width: 200px;
    line-height: 30px;
    text-align: center;
    margin-left:-100px;
    background: rgba(0,0,0,.5);
    color: #fff;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layer/toastTips.vue